import { render, staticRenderFns } from "./w-store.vue?vue&type=template&id=12caf0f2"
import script from "./w-store.vue?vue&type=script&lang=js"
export * from "./w-store.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports